const normalizeSelectValue = value => {
  if (value === null || value === undefined || value === "") {
    return value;
  }

  if (typeof value === "number") {
    return value;
  }

  if (typeof value !== "string" || value.trim() === "") {
    return value;
  }

  const numericValue = Number(value);

  return Number.isNaN(numericValue) ? value : numericValue;
};

const selectOptionValue = value => {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return value.value;
  }

  return value;
};

const sameSelectOptionValue = (left, right) => {
  return normalizeSelectValue(selectOptionValue(left)) === normalizeSelectValue(selectOptionValue(right));
};

const isValidFilterValue = value => !(typeof value === "number" && Number.isNaN(value));

module.exports = {
  isValidFilterValue,
  normalizeSelectValue,
  sameSelectOptionValue,
  selectOptionValue,
};
